import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

export interface DialogData {
  summary: string;
}

@Component({
  selector: 'inbox-summarize-conversation-dialog.component',
  templateUrl: 'summarize-conversation-dialog.component.html',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, TranslateModule],
})
export class SummarizeConversationDialogComponent {
  readonly data = inject(MAT_DIALOG_DATA);

  constructor(public dialogRef: MatDialogRef<SummarizeConversationDialogComponent>) {}

  ok(): void {
    this.dialogRef.close();
  }
}
